import React from "react";
import _ from "lodash";
import TextCard from "../text-card";
import { useStepContainerStyles } from "../../lib/constants";
import { Slide } from "@material-ui/core";
import { useSelector } from "react-redux";

export default function Step1Container(props) {
  const { content, onClickCard, needResize } = props;
  const stepContainerClasses = useStepContainerStyles({
    scrolling: needResize[1]
  });

  const pageNumber = useSelector((state) => state.pageNumber);
  const checkedStepOne = useSelector((state) => state.checkedCardStepOne);

  const directionOnEnter = checkedStepOne ? "down" : "up";
  const directionOnLeave = checkedStepOne ? "up" : "down";

  return (
    <Slide
      direction={pageNumber === 1 ? directionOnEnter : directionOnLeave}
      in={pageNumber === 1}
      timeout={500}
      mountOnEnter
      unmountOnExit
    >
      <div className={stepContainerClasses.textContainerGrid}>
        {_.map(content, (text, index) => (
          <TextCard
            header={text[0]}
            text={text[1]}
            onCheck={(text) => onClickCard(text)}
            key={`text-card-step-one-${index}`}
            id={index}
            resize={needResize}
          />
        ))}
      </div>
    </Slide>
  );
}
